import React from "react";

import styles from "./style.module.scss";
import { OrderShipmentInfo } from ".";
import { LocalisedText } from "../../i18n";

interface OrderShipmentInfoDetailsProps {
  currentShipmentInfo: OrderShipmentInfo;
}

const OrderShipmentInfoDetails: React.FC<OrderShipmentInfoDetailsProps> = props => {
  const { currentShipmentInfo } = props;

  return (
    <div className={styles.shipmentInfoDetails}>
      <div className={styles.shipmentInfoDetailsItem}>
        <div>
          <LocalisedText id="view.orderShipmentInfoDetails.carrier" />
        </div>
        <div className={styles.shipmentInfoDetailsItemValue}>
          {currentShipmentInfo.deliverBy}
        </div>
      </div>
      <div className={styles.shipmentInfoDetailsItem}>
        <div>
          <LocalisedText id="view.orderShipmentInfoDetails.trackingNo" />
        </div>
        <div className={styles.shipmentInfoDetailsItemValue}>
          {currentShipmentInfo.trackingNumber}
        </div>
      </div>
    </div>
  );
};

export default OrderShipmentInfoDetails;
